export default "__VITE_ASSET__BdR8s4f6__"